import { render, staticRenderFns } from "./InscriptionCredits.vue?vue&type=template&id=7fffbee2"
import script from "./InscriptionCredits.vue?vue&type=script&lang=js"
export * from "./InscriptionCredits.vue?vue&type=script&lang=js"
import style0 from "./InscriptionCredits.vue?vue&type=style&index=0&id=7fffbee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports